import React from 'react';
import { Typography, Box, ButtonBase } from '@mui/material';
import { makeStyles } from '@mui/styles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

type Props = {
  title: string;
  renderBackArrow: boolean;
  handlePreviousClick: () => void;
};

export const SATableHeader: React.FC<Props> = ({ title, renderBackArrow, handlePreviousClick }) => {
  const classes = useStyles()();
  return (
    <Box my={2}>
      {renderBackArrow && (
        <div>
          <Box display="flex" alignItems="center" mr={2}>
            <ButtonBase onClick={handlePreviousClick} className={classes.button}>
              <ArrowBackIcon fontSize="large" />
            </ButtonBase>
            <Typography variant="h2">{title}</Typography>
          </Box>
        </div>
      )}
    </Box>
  );
};

const useStyles = () =>
  makeStyles(() => ({
    button: {
      marginRight: '14px !important'
    }
  }));
